import React, { useState } from 'react';
import { FiSend } from 'react-icons/fi';

export function QuestionCommentsPlayful({ comments, onAddComment }) {
  const [text, setText] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    if (!text.trim() || submitting) return;

    setSubmitting(true);
    await onAddComment(text);
    setText('');
    setSubmitting(false);
  };

  return (
    <div className="mt-4 space-y-3 border-t border-neutral-100 pt-4">
      {comments.map(comment => (
        <div
          key={comment.id}
          className="rounded-2xl bg-neutral-50 p-3"
        >
          <span className="block text-sm font-bold">{comment.user?.name}</span>
          <p className="mb-0 text-sm text-neutral-600">{comment.body}</p>
        </div>
      ))}

      <form
        className="flex items-center gap-2"
        onSubmit={handleSubmit}
      >
        <textarea
          placeholder="Escreva um comentário"
          aria-label="Escreva um comentário"
          value={text}
          onChange={e => setText(e.target.value)}
          rows={1}
          className="flex-1 resize-none rounded-2xl border border-neutral-lighter px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-[var(--color-secondary)]"
        />
        <button
          type="submit"
          aria-label="Enviar"
          disabled={submitting}
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-white transition-transform active:scale-95"
          style={{ background: 'var(--color-secondary)' }}
        >
          <FiSend className="h-4 w-4" />
        </button>
      </form>
    </div>
  );
}
